// ESM, not `require`. This module already used `export default`, so the CJS
// require made it a mixed-syntax file: the bundler resolved it at build time,
// but the dev server ships modules to the browser as-is, where `require` is
// simply undefined — which took the whole app down locally, not just this
// route, since the store imports every reducer at boot.
import { RESET_FORM, SIGN_IN_REQUEST } from "./constants";

const initialState = {
  resetForm: false,
  submittedEmail: '',
};

function signInPageReducer(state = initialState, action) {
  switch (action.type) {
    case SIGN_IN_REQUEST:
      return {
        ...state,
        submittedEmail: action.payload?.email || '',
      };
    case RESET_FORM:
      return {
        ...state,
        resetForm: action.payload,
      };
    default:
      return state;
  }
}

export default signInPageReducer;
